import type { ConceptDef } from '../types';

export const echoicSongs: ConceptDef = {
  kind: 'supervisorScored',
  id: 'echoic-songs',
  label: 'Echoic Songs',
  category: 'Echoic',
  description: 'Sing a familiar line; learner repeats it. Supervisor scores.',
  config: {
    promptMode: 'AUDIO',
    prompts: [
      { prompt: 'Twinkle, twinkle, little star.' },
      { prompt: 'Mary had a little lamb.' },
      { prompt: 'The wheels on the bus go round and round.' },
      { prompt: 'Row, row, row your boat.' },
      { prompt: 'Old MacDonald had a farm.' },
    ],
  },
};
